// src/components/ModalRemision.jsx
import React, { useState } from "react";
import Breadcrumb from "./Breadcrumb";
import { getClienteInfo } from "../utils/clientes";
//import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia";

export default function ModalRemision(props) {
  const {
    onGuardar = () => {},
    onCancelar = () => {},
    datos = [],
    añadirFila,
    eliminar,
    actualizarCantidad,
    handleInputChange,
    setDatos,
    calcularSubtotal,
    descuento,
    manejarCambioDescuento,
    iva,
    total,
    clientes = [],
    cliente,
    setCliente,
    divisa,
    setDivisa,
    catalogo = [],
    filteredProductos = [],
    setFilteredProductos,
    fechaCotizacion,
    abrirConfiguracion,
    numeroSobrescrito,
    numeroRemisionAuto,
    tiempoEntrega = "15 días",
    condicionesPago = "30% anticipo, 70% contra entrega",
    notas = "",
    setTiempoEntrega,
    setCondicionesPago,
    setNotas,
    descMode,
    toggleDescMode,
    setFechaCotizacion,
    totalDescuentoGlobal,
    overIndex,
    onRowDragStart,
    onRowDragOver,
    onRowDrop,
    onRowDragEnd,
    numeroCotizacion,
    onOpenSelectorCotizacion,
  } = props;

  const numeroParaChip = (
    numeroSobrescrito != null && numeroSobrescrito !== ""
      ? numeroSobrescrito
      : numeroRemisionAuto ?? "0001"
  ).toString();
  const [openPicker, setOpenPicker] = useState(null);
  const [hi, setHi] = useState(0);

  const fmtMoney = (n) =>
    Number(n || 0).toLocaleString("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  const clienteInfo = getClienteInfo(clientes, cliente);
  // Estados base
  //const { formatDate } = useFunctionsPrevia();

  return (
    <div className="modal-cotizacion">
      {/* ======= HEADER IGUAL AL DE TABLA ======= */}
      <div className="task-filters" style={{ flexWrap: "wrap" }}>
        <div style={{ flexBasis: "100%", padding: "0 4px", margin: "0 0 5px" }}>
          <Breadcrumb lastLabel="Crear Remisión" />
        </div>

        <div
          className="header-actions-proyectos"
          aria-hidden="true"
          style={{ visibility: "hidden", pointerEvents: "none" }}
        >
          <button className="action-button-proyectos">
            <i className="bi bi-funnel-fill"></i> Todos
            <i className="bi bi-chevron-down" style={{ fontSize: "12px" }}></i>
          </button>
          <div className="buscador-pedidos">
            <i className="bi bi-search"></i>
            <input
              type="text"
              className="buscador-input"
              placeholder="Buscar cotizaciones..."
              defaultValue=""
              readOnly
            />
          </div>
        </div>

        <div className="task-filters-right">
          <div
            className="view-buttons-container"
            style={{ visibility: "hidden", pointerEvents: "none" }}
          >
            <div className="delete-button-container">
              <button type="button" className="delete-button">
                Eliminar
              </button>
            </div>
            <button className="view-button">
              <i className="bi bi-three-dots-vertical"></i>
            </button>
          </div>

          <button
            type="button"
            className="btn-cancel"
            onClick={onCancelar}
            title="Cancelar"
          >
            <i className="bi bi-x-circle"></i> Cancelar
          </button>

          <button
            type="button"
            className="new-task-button"
            onClick={onGuardar}
            title="Guardar"
          >
            <i className="bi bi-save"></i> Guardar
          </button>
        </div>
      </div>
      {/* ======= /HEADER ======= */}

      {/* ======= CONTENEDOR MAESTRO ======= */}
      <div className="coti-shell">
        <div className="coti-content">
          <div className="coti-sheet">
            {/* ===== Cuerpo que empuja el pie al fondo ===== */}
            <div className="coti-body">
              {/* TOP: Logo + chips derecha */}
              <div className="coti-top">
                <div className="coti-brand">
                  <img src="/img/logo-comercial.svg" alt="Logo" />
                </div>

                <div className="coti-facts">
                  <div className="fact">
                    <small>Remisión</small>
                    <div className="coti-number">
                      <span className="coti-number-value">
                        #{numeroParaChip}
                      </span>
                      <button
                        type="button"
                        className="coti-number-edit"
                        onClick={abrirConfiguracion}
                        title="Configurar numeración"
                        aria-label="Configurar numeración"
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>
                    </div>
                  </div>

                  <div className="fact">
                    <small>Fecha</small>
                    <input
                      type="date"
                      className="chip chip--picker date-chip"
                      value={
                        fechaCotizacion
                          ? new Date(fechaCotizacion).toISOString().slice(0, 10)
                          : new Date().toISOString().slice(0, 10) // 👈 por defecto hoy
                      }
                      onChange={(e) => {
                        const v = e.target.value; // "YYYY-MM-DD"
                        const fecha = v ? new Date(`${v}T00:00:00`) : null;
                        setFechaCotizacion(fecha);
                      }}
                    />
                  </div>

                  <div className="fact">
                    <small>Cotización</small>
                    <div className="coti-number">
                      <span className="coti-number-value">
                        {numeroCotizacion || "Sin asignar"}
                      </span>
                      <button
                        type="button"
                        className="coti-number-edit"
                        onClick={onOpenSelectorCotizacion}
                        title="Seleccionar cotización"
                        aria-label="Seleccionar cotización"
                      >
                        <i className="bi bi-search" />
                      </button>
                    </div>
                  </div>
                  <div className="fact">
                    <small>Moneda</small>
                    <select
                      className="coti-select"
                      value={divisa}
                      onChange={(e) => setDivisa(e.target.value)}
                    >
                      <option value="MXN">MXN</option>
                      <option value="USD">USD</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="coti-line" />

              {/* GRID: izquierda form / derecha panel */}
              <div className="coti-grid">
                {/* ===== IZQUIERDA: BLOQUE CLIENTE + TABLA ===== */}
                <section className="coti-left">
                  {/* ---- Cliente ---- */}
                  <div className="box-title">CLIENTE</div>

                  <div className="client-select-row">
                    <label htmlFor="cliente" className="sr-only">
                      Cliente
                    </label>
                    <select
                      id="cliente"
                      name="cliente"
                      className="client-select"
                      value={cliente || ""}
                      onChange={(e) => setCliente(e.target.value)}
                    >
                      <option value="">Selecciona un cliente</option>
                      {clientes
                        .slice()
                        .sort((a, b) =>
                          (a.empresa || "").localeCompare(b.empresa || "")
                        )
                        .map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.empresa}
                          </option>
                        ))}
                    </select>
                  </div>

                  {clienteInfo && (
                    <div className="client-meta">
                      {clienteInfo.linea1 && (
                        <div className="client-line">{clienteInfo.linea1}</div>
                      )}

                      {clienteInfo.linea2 && (
                        <div className="client-line">{clienteInfo.linea2}</div>
                      )}

                      {clienteInfo.contacto && (
                        <div className="client-line">
                          {clienteInfo.contacto}
                        </div>
                      )}

                      {clienteInfo.rfc && (
                        <div className="client-line">
                          <strong>RFC:</strong> {clienteInfo.rfc}
                        </div>
                      )}
                    </div>
                  )}
                </section>

                {/* ===== DERECHA: PANEL RESUMEN ===== */}
                <aside className="coti-right">
                  <div className="summary-card">
                    <div className="summary-title">REMISIÓN</div>
                    <button type="button" className="total-box" disabled>
                      <small>Total</small>
                      <div className="amount">
                        {divisa}{" "}
                        {Number(total).toLocaleString("es-MX", {
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </button>
                  </div>
                </aside>

                <div className="items-table">
                  {/* Cabecera */}
                  <div className="items-head">
                    <div>No.</div>
                    <div>Descripción</div>
                    <div>Código o parte</div>
                    <div>Cantidad</div>
                    <div>Precio</div>
                    <div>Descuento</div>
                    <div>Subtotal</div>
                  </div>

                  {/* Filas */}
                  {/* ===== Filas ===== */}
                  <div className="items-body">
                    {datos.map((r, idx) => (
                      <div
                        key={r.id}
                        className={`items-row ${
                          overIndex === idx ? "is-drop-target" : ""
                        }`}
                        draggable
                        onDragStart={() => onRowDragStart?.(idx)}
                        onDragOver={(e) => onRowDragOver?.(e, idx)}
                        onDrop={() => onRowDrop?.(idx)}
                        onDragEnd={onRowDragEnd}
                      >
                        {/* No. */}
                        <div className="num-cell">
                          <i className="bi bi-grip-vertical" />
                          <span className="num-badge">{idx + 1}</span>
                        </div>

                        {/* Descripción (input) + SELECT emergente con TODO el catálogo */}
                        <div className="desc-cell">
                          {/* Descripción */}
                          <input
                            type="text"
                            className="input"
                            placeholder="Descripción"
                            value={r.nombre}
                            onChange={(e) => handleInputChange(e, r.id)}
                            onFocus={() => {
                              setOpenPicker(r.id);
                              // siempre repuebla con todo el catálogo al enfocar
                              if (catalogo?.length)
                                setFilteredProductos(catalogo);
                              setHi(0);
                            }}
                          />

                          {/* PICKER flotante: sin "cargando…" */}
                          {openPicker === r.id && (
                            <div
                              className="product-picker"
                              role="listbox"
                              aria-label="Productos"
                              tabIndex={-1}
                              onKeyDown={(e) =>
                                e.key === "Escape" && setOpenPicker(null)
                              }
                            >
                              {(
                                (filteredProductos?.length
                                  ? filteredProductos
                                  : catalogo) || []
                              ).length > 0 && (
                                <ul className="product-picker-list">
                                  {(filteredProductos?.length
                                    ? filteredProductos
                                    : catalogo
                                  ).map((p, idx) => (
                                    <li key={p.id}>
                                      <button
                                        type="button"
                                        className={`picker-item ${
                                          idx === hi ? "is-active" : ""
                                        }`}
                                        onMouseEnter={() => setHi(idx)}
                                        onMouseDown={(e) => {
                                          e.preventDefault(); // seleccionar antes del blur
                                          handleInputChange(
                                            { target: { value: p.nombre } },
                                            r.id
                                          );
                                          setOpenPicker(null);
                                        }}
                                        title={p.nombre}
                                      >
                                        <span className="picker-name">
                                          {p.nombre || p.descripcion || "—"}
                                        </span>
                                        <span className="picker-meta">
                                          {p.numeroDeParteProveedor || ""}
                                        </span>
                                        <span className="picker-price">
                                          {typeof p.costo === "number"
                                            ? `$ ${p.costo.toLocaleString(
                                                "es-MX",
                                                { minimumFractionDigits: 2 }
                                              )}`
                                            : ""}
                                        </span>
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              )}
                              {/* Si aún no hay datos, no mostramos nada (sin “cargando…”) */}
                            </div>
                          )}

                          <textarea
                            className="textarea"
                            placeholder="Detalle (opcional)"
                            rows={3}
                            value={r.descripcion || ""}
                            onChange={(e) =>
                              setDatos((prev) =>
                                prev.map((x) =>
                                  x.id === r.id
                                    ? { ...x, descripcion: e.target.value }
                                    : x
                                )
                              )
                            }
                          />
                        </div>

                        {/* Código / parte */}
                        <div>
                          <input
                            type="text"
                            className="input"
                            placeholder="Código / parte"
                            value={r.numeroDeParteProveedor || ""}
                            onChange={(e) =>
                              setDatos((prev) =>
                                prev.map((x) =>
                                  x.id === r.id
                                    ? {
                                        ...x,
                                        numeroDeParteProveedor: e.target.value,
                                      }
                                    : x
                                )
                              )
                            }
                          />
                        </div>

                        {/* Cantidad */}
                        <div className="qty-cell">
                          <input
                            type="number"
                            min="0"
                            step="1"
                            className="input"
                            value={r.cantidad ?? 1}
                            onChange={(e) =>
                              actualizarCantidad(
                                r.id,
                                Number(e.target.value) || 0
                              )
                            }
                          />
                        </div>

                        {/* Precio unitario (tarifa) */}
                        <div
                          className="price-wrap"
                          title={`${divisa} ${Number(r.tarifa || 0).toFixed(
                            2
                          )}`}
                        >
                          <span className="cur">
                            {divisa === "MXN" || divisa === "USD" ? "$" : ""}
                          </span>

                          <input
                            type="text"
                            inputMode="decimal"
                            className="price-input"
                            placeholder="0.00"
                            value={Number(r.tarifa || 0).toLocaleString(
                              "es-MX",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                            onChange={(e) => {
                              const raw = e.target.value
                                .replace(/[^\d.,]/g, "")
                                .replace(/,/g, "");
                              const num =
                                parseFloat(raw.replace(",", ".")) || 0;
                              setDatos((prev) =>
                                prev.map((x) =>
                                  x.id === r.id
                                    ? {
                                        ...x,
                                        tarifa: num,
                                        importe: num * (x.cantidad || 0),
                                      }
                                    : x
                                )
                              );
                            }}
                            onBlur={(e) => {
                              const raw = e.target.value
                                .replace(/[^\d.,]/g, "")
                                .replace(/,/g, "");
                              const num =
                                parseFloat(raw.replace(",", ".")) || 0;
                              setDatos((prev) =>
                                prev.map((x) =>
                                  x.id === r.id
                                    ? {
                                        ...x,
                                        tarifa: num,
                                        importe: num * (x.cantidad || 0),
                                      }
                                    : x
                                )
                              );
                            }}
                          />
                        </div>

                        <div className="disc-cell">
                          <div className="disc-inner">
                            <input
                              type="text"
                              inputMode="decimal"
                              className="desc-input" // reutiliza el estilo del descuento global
                              placeholder="0"
                              value={r.descuento ?? 0}
                              onChange={(e) => {
                                const raw = e.target.value
                                  .replace(/[^\d.,]/g, "")
                                  .replace(",", ".");
                                let n = parseFloat(raw);
                                if (isNaN(n)) n = 0;

                                const tipo = r.tipoDescuento || "%";
                                if (tipo === "%" && n > 100) n = 100; // limitar a 100% si es porcentaje

                                setDatos((prev) =>
                                  prev.map((x) =>
                                    x.id === r.id ? { ...x, descuento: n } : x
                                  )
                                );
                              }}
                            />
                            <button
                              type="button"
                              className={`desc-mode ${
                                (r.tipoDescuento || "%") === "%"
                                  ? "is-active"
                                  : ""
                              }`}
                              title={
                                (r.tipoDescuento || "%") === "%"
                                  ? "Descuento en porcentaje"
                                  : "Descuento en monto"
                              }
                              onClick={() => {
                                setDatos((prev) =>
                                  prev.map((x) =>
                                    x.id === r.id
                                      ? {
                                          ...x,
                                          tipoDescuento:
                                            (x.tipoDescuento || "%") === "%"
                                              ? "$"
                                              : "%",
                                        }
                                      : x
                                  )
                                );
                              }}
                            >
                              {r.tipoDescuento || "%"}
                            </button>
                          </div>
                        </div>

                        {/* Subtotal por fila (usa importe/tarifa*cantidad con descuento de fila si lo usaras) */}
                        <div className="subtotal-cell">
                          {(() => {
                            const tarifa = Number(r.tarifa) || 0;
                            const cantidad = Number(r.cantidad) || 0;
                            const base = tarifa * cantidad;

                            const d = Number(r.descuento) || 0;
                            const tipo = r.tipoDescuento || "%";

                            let descLinea =
                              tipo === "%"
                                ? base * (d / 100) // % por partida
                                : d; // $ por partida

                            if (descLinea > base) descLinea = base;

                            const subtotalLinea = base - descLinea;

                            return (
                              <span className="subtotal-amount">
                                {divisa === "MXN" ? "$" : ""}
                                {subtotalLinea.toLocaleString("es-MX", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}{" "}
                                {divisa}
                              </span>
                            );
                          })()}

                          <button
                            type="button"
                            className="row-action more"
                            title="Opciones"
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                          <button
                            type="button"
                            className="row-action danger"
                            title="Eliminar fila"
                            onClick={() => eliminar(r.id)}
                          >
                            <i className="bi bi-x-lg"></i>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Botón agregar fila */}
                  <button
                    type="button"
                    className="add-row"
                    onClick={añadirFila}
                  >
                    <i className="bi bi-plus-circle"></i> Añadir Producto
                  </button>
                </div>

                {/* ===== Footer: Términos (izq) / Totales (der) ===== */}
                <div className="coti-footer">
                  {/* IZQUIERDA */}
                  <section className="tc-card">
                    <div className="tc-head">Términos y Condiciones</div>

                    <div className="tc-row">
                      <i className="bi bi-clock-history" />
                      <label>Tiempo de Entrega:</label>
                      <input
                        className="input"
                        value={tiempoEntrega}
                        onChange={(e) => setTiempoEntrega(e.target.value)}
                        placeholder="Ej. 15 días"
                      />
                    </div>

                    <div className="tc-row">
                      <i className="bi bi-file-earmark-text" />
                      <label>Condiciones de Pago:</label>
                      <input
                        className="input"
                        value={condicionesPago}
                        onChange={(e) => setCondicionesPago(e.target.value)}
                        placeholder="Ej. 30% anticipo, 70% contra entrega"
                      />
                    </div>

                    <div className="tc-notas">
                      <label>Notas Adicionales:</label>
                      <textarea
                        className="textarea"
                        rows={3}
                        value={notas}
                        onChange={(e) => setNotas(e.target.value)}
                        placeholder="Observaciones para el cliente"
                      />
                    </div>
                  </section>

                  {/* DERECHA */}
                  <aside className="totals-card">
                    <div className="totals-grid">
                      <div className="total-row">
                        <dt>Subtotal</dt>
                        <dd>
                          {divisa} {fmtMoney(calcularSubtotal())}
                        </dd>
                      </div>

                      <div className="total-row is-desc">
                        <dt>Descuento</dt>
                        <dd className="desc-dd">
                          <input
                            className="desc-input"
                            inputMode="decimal"
                            placeholder="0"
                            value={descuento}
                            onChange={manejarCambioDescuento}
                            title={
                              descMode === "%"
                                ? "Descuento en porcentaje"
                                : "Descuento en monto"
                            }
                          />
                          <button
                            type="button"
                            className={`desc-mode ${
                              descMode === "%" ? "is-active" : ""
                            }`}
                            onClick={toggleDescMode}
                          >
                            {descMode}
                          </button>
                        </dd>
                      </div>

                      {/* 👇 SOLO SE MUESTRA SI HAY DESCUENTO */}
                      {Number(totalDescuentoGlobal) > 0 && (
                        <div className="total-row">
                          <dt>Descuento aplicado</dt>
                          <dd>
                            {divisa} {fmtMoney(totalDescuentoGlobal)}
                          </dd>
                        </div>
                      )}

                      <div className="total-row">
                        <dt>IVA (16%)</dt>
                        <dd>
                          {divisa}{" "}
                          {Number(iva).toLocaleString("es-MX", {
                            minimumFractionDigits: 2,
                          })}
                        </dd>
                      </div>
                    </div>

                    <div className="grand-total">
                      <span>Total</span>
                      <span>
                        {divisa}{" "}
                        {Number(total).toLocaleString("es-MX", {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  </aside>

                  {/* ===== Firma ===== */}
                  <div className="firma-section">
                    <div className="firma-block">
                      <img
                        className="firma-img"
                        src="/img/firma.png"
                        alt="Firma"
                      />
                      <div className="firma-line" />
                      <div className="firma-nombre">VÍCTOR GARCÍA</div>
                      <div className="firma-puesto">PROYECTOS</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== Pie de página con línea azul ===== */}
            <div className="coti-bottom">
              <div className="coti-bottom-line" />
              <div className="coti-footerbar">
                <span>{clienteInfo?.empresaUpper}</span>
                <span>1</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ======= /CONTENEDOR MAESTRO ======= */}
    </div>
  );
}
